import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';

class ASHeader extends Component {
  logout() {
    this.props.logout();
  }

  componentDidMount(){
  }

  componentWillMount(){
  }

  componentWillUpdate(){
     const x = document.getElementById("myTopnav");
     if (x.className.indexOf('responsive')>0){
        x.className = "topnav";
     }
  }

  menuClick(e){
    e.preventDefault();
    const x = document.getElementById("myTopnav");
    if (x.className === "topnav") {
        x.className += " responsive";
    } else {
        x.className = "topnav";
    }
  }

  render() {
    const renderLogonComponent = () => {
      if (this.props.profile){
        const { imageUrl, name } = this.props.profile;  
        return (
            <div className="menuAccountContainer dropdownMenu">
                <button className="dropbtn"><Avatar src={imageUrl} /></button>
                <div className="dropdown-content">
                  <a href="#" className="topDropLink" onClick={this.logout.bind(this)}>Logout</a>
                </div>
            </div>
          )
      }
    }

    return (
      <header className="app-header topnavBackground">
        <div className='container'>
          <div className="topnav" id="myTopnav">
                <Link to="/" className='logo active' >
                  ADMIN&nbsp;<span className="badge badge-pill badge-warning" style={{fontSize: '8px'}}>0.61.1</span>
                </Link>
                
                {this.props.profile?(
                    <div className="menuDashboardContainer topDropMenu">
                        <button className="topDropButton">Tasks</button>
                        <div className='topDrop-content'>
                            <Link to="/" className='topDropLink' >
                                Tasks Management
                            </Link>
                            <Link to="/workers" className='topDropLink' >
                                Workers Management
                            </Link>
                        </div>
                    </div>
                ):null}

                {this.props.profile?(
                    <div className="menuProjectContainer topDropMenu ">
                        <button className="topDropButton">Others</button>
                        <div className="topDrop-content">
                            <Link to="/gorgonForms/prod" className='topDropLink' >
                                Gorgon Forms Questions- Production
                            </Link>
                            <Link to="/gorgonForms/test" className='topDropLink' >
                                Gorgon Forms Questions - Testing
                            </Link>
                        </div>
                    </div>
                ):null}

                {this.props.profile?(
                    <div className="menuProjectContainer topDropMenu ">
                        <button className="topDropButton">Reports</button>
                        <div className="topDrop-content">
                            <Link to="/apolloXmlCountReports" className='topDropLink' >
                                Apollo XML Count
                            </Link>
                            <Link to="/bellerophonXmlCountReports" className='topDropLink' >
                                Bellerophon XML Count
                            </Link>
                            <Link to="/admProjectBillableWorkflows" className='topDropLink' >
                                Projects Billable Workflows
                            </Link>
                        </div>
                    </div>
                ):null}
                
                {renderLogonComponent()}
                <a href="javascript:void(0);" style={{fontSize:'15px'}} className="icon" onClick={(e)=>this.menuClick(e)}>&#9776;</a>
          </div>
        </div>
       </header>
      )
    
  }
}

const mapStateToProps = (state) => {
  return state;
}

export default connect(mapStateToProps)(ASHeader)


// WEBPACK FOOTER //
// ./src/components/Header/ASHeader.js